export default

    class VehicleType {

    constructor(description, client_id, capacity) {
        this.description = description
        this.client_id = client_id
        this.capacity = capacity
    }
}